import axiosClient from './utils/axiosClient';

export const PROMPT_URI = 'prompt';

export function getAiReviewPromptMessageApi(promptType) {
    return axiosClient.get(`${PROMPT_URI}/message?type=${promptType}`);
}